export const fetchJson = async <T,>(input: RequestInfo | URL, init?: RequestInit) => {
  const response = await fetch(input, init);
  const contentType = response.headers.get("content-type") ?? "";
  const rawText = await response.text();
  const hasJson = rawText.length > 0 && contentType.includes("application/json");
  let data: T | null = null;
  if (hasJson) {
    try {
      data = JSON.parse(rawText) as T;
    } catch {
      data = null;
    }
  }
  if (!response.ok) {
    const message = (data as { error?: string } | null)?.error ?? "request_failed";
    throw new Error(message);
  }
  if (data === null) {
    throw new Error("invalid_json_response");
  }
  return data;
};
